export default "__VITE_ASSET__BxzgFlDk__"